import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { BiContainer, IconButton, DropdownMenu, DropdownMenuItem } from 'seagull';
import { ArrowDown, ArrowUp, Kebab, Trash } from 'seagull/icons';
import { useServiceAdvancedSettingsAdditionalSection } from '~/components/ServiceAdvancedSettings';
import ServicePanel, { getTestId } from '~/components/ServicePanel/ServicePanel';
import { useLocaleKeys } from '~/i18n';
import { agentTargetForService } from '../../AgentChangeHighlight/agentTargetSets';
import styles from './DraftServiceInstance.module.scss';
const DraftServiceInstance = /*#__PURE__*/ forwardRef(function DraftServiceInstance(props, ref) {
    const { t: draftServiceInstanceTexts } = useLocaleKeys('components.agreementStudio.draftServiceInstance');
    const { service, idx, canMoveDown, canMoveUp, isInvalid, isReadOnly = false, advancedSettingsProps, showErrors, serviceDetailsProps, onEditServiceNameAndDescription, onRemoveService, onMoveDown, onMoveUp, isDragActive, dragHandle } = props;
    const serviceAdvancedSettingsAdditionalSection = useServiceAdvancedSettingsAdditionalSection(_object_spread_props(_object_spread({}, advancedSettingsProps), {
        service,
        isReadOnly,
        testId: "draft-service-".concat(idx)
    }));
    return /*#__PURE__*/ _jsx(BiContainer, {
        name: "service_card",
        data: {
            serviceId: service.id
        },
        children: /*#__PURE__*/ _jsx("div", {
            "data-agent-target": agentTargetForService(service.id),
            children: /*#__PURE__*/ _createElement(ServicePanel, _object_spread_props(_object_spread({
                serviceOrigin: "draft",
                isVendor: true,
                showBadges: true,
                billingInitiationProps: {
                    isExistingService: false
                },
                ignoreAmendments: true,
                context: "draft"
            }, serviceDetailsProps), {
                key: service.id || idx,
                ref: ref,
                service: service,
                idx: idx,
                error: showErrors && isInvalid,
                isReadOnly: isReadOnly,
                additionalSections: [
                    serviceAdvancedSettingsAdditionalSection
                ],
                onEditServiceNameAndDescription: onEditServiceNameAndDescription,
                isDragActive: isDragActive,
                dragHandle: dragHandle,
                menu: !isReadOnly && !isDragActive && /*#__PURE__*/ _jsx("div", {
                    className: styles.inlineMenu,
                    children: /*#__PURE__*/ _jsxs(DropdownMenu, {
                        target: /*#__PURE__*/ _jsx(IconButton, {
                            bi: {
                                name: 'service_menu'
                            },
                            className: styles.ellipsisMenu,
                            testId: "".concat(getTestId(idx), "ellipsis-menu"),
                            children: /*#__PURE__*/ _jsx(Kebab, {})
                        }),
                        children: [
                            (canMoveDown || canMoveUp) && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                        bi: {
                                            name: 'move_up'
                                        },
                                        iconStart: /*#__PURE__*/ _jsx(ArrowUp, {}),
                                        testId: "".concat(getTestId(idx), "move-up"),
                                        disabled: !canMoveUp,
                                        onClick: onMoveUp,
                                        children: draftServiceInstanceTexts.moveUp()
                                    }),
                                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                        bi: {
                                            name: 'move_down'
                                        },
                                        iconStart: /*#__PURE__*/ _jsx(ArrowDown, {}),
                                        testId: "".concat(getTestId(idx), "move-down"),
                                        disabled: !canMoveDown,
                                        onClick: onMoveDown,
                                        children: draftServiceInstanceTexts.moveDown()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                bi: {
                                    name: 'remove_service'
                                },
                                iconStart: /*#__PURE__*/ _jsx(Trash, {}),
                                testId: "".concat(getTestId(idx), "remove-service"),
                                disabled: isReadOnly,
                                onClick: ()=>onRemoveService(service.id),
                                skin: "error",
                                children: draftServiceInstanceTexts.remove()
                            })
                        ]
                    })
                })
            }))
        })
    });
});
export default DraftServiceInstance;
